<template>
  <section class="standard"  v-loading.fullscreen.lock="loading">
    <div class="standard-header">
      <com-tabs
        @change="changeTab"
        :list="statisticsInfo.obj.tabs4"
        class="standard-tabs"
        :defaultTab="activeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="standard-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <span class="btn2">新建</span>
      <span class="btn1">删除</span>
      <span class="btn1">上报</span>
      <span class="btn1">导出</span>
    </div>

    <div class="standard-content">
      <com-term0 
        :data="data1"
        v-show="activeTab == 0" 
        />
     
    </div>
  </section>
</template>
<script>
import mock from "@/utils/mock";
import comTabs from "@/components/comTabs";
import comTerm0 from "./details/comTerm0.vue";
export default {
  name: "comStandard",
  components: {
    comTabs,
    comTerm0,
  },
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      loading:true,
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      data1:null,
     
    };
  },
  mounted() {
    this.tableMode()
  },
  methods: {
    async tableMode() {
      let obj = await this.statisticsInit.tableMode();
      this.data1 = obj.slice(0, 22);
      this.loading = false;
      this.data2 = obj.slice(22, 130);
      this.data3 = obj.slice(130,176);
      this.data4 = obj.slice(176,238);
      this.data5 = obj.slice(238,317);
      this.data6 = obj.slice(317,344);
      this.data7 = obj.slice(344, 352);
    },
    changeTab(x, y) {
      this.activeTab = x;
    },
    handlePrePage() {
      if(this.activeTab ==0){
        this.$message({
          type:"error",
          message:"当前已为第一章"
        })
      }else{
        this.activeTab -= 1;
      }
      
    },
    handleNextPage() {
      if(this.activeTab ==6){
        this.$message({
          type:"error",
          message:"当前已为最后一章"
        })
      }else{
        this.activeTab += 1;
      }
      
    },
  },
};
</script>
<style lang="scss" scoped>
.standard {
  margin-top: 20px;
  &-header {
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
      padding: 6px 20px;
      border-radius: 5px;
    }
    .btn1 {
      background-color: #fff;
      border: 1px solid #d7d4d4;
      color: #333;
    }
    .btn2 {
      background-color: #2f82ff;
      border: 1px solid #2f82ff;
      color: #fff;
    }
  }
  &-tabs {
    width: 700px !important;
    display: flex;
    // flex-direction: column;
    margin-right: 18px;
    margin-left: 20px;

    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-bottom: 2px solid #2f82ff;
    }
  }
  &-content {
    margin-top: 22px;
  }
}
.standard /deep/ .tabs {
  justify-content: space-around;
  > div {
    flex: none;
  }
}
</style>
